<template>
	<div class="row">
		<div class="col-12 progress-wrapper">
			<div
				v-for="phase in phases"
				:style="`left: calc((100% - 30px) * ${ Math.ceil(phase.percentage / 2) * 2 / 100 } + 15px)`"
				:class="{ active: percentage >= phase.percentage }"
				class="step"
			>
				<span>{{ phase.name }}</span>
			</div>
			<div class="scissors-progress-bar">
				<div :style="'width: ' + Math.ceil((current/total)*100 / 2) * 2 + '%;'"></div>
			</div>
		</div>
		<div class="progress-percentage">
			<span class="number">{{ percentage }} %</span> {{ $tr.progressConfigured }}
		</div>
	</div>
</template>

<script>
	export default {
		name: "Progress",
		props: [
			"current",
			"total",
			"phases"
		],
		computed: {
			percentage() {
				return Math.round(this.current * 100 / this.total);
			}
		}
	}
	//:style="`left: calc((100% - 30px) * ${phase.percentage ? phase.percentage / 100 : (phase.step - 1) / total } + 15px)`"
</script>
